import React, { useState} from 'react';
import { Link } from 'react-router-dom';

// Import Images
import bg1 from '../../images/background/line-bg1.png';
import ptImg1 from '../../images/shap/circle-orange.png';
import ptImg2 from '../../images/shap/plus-orange.png';
import ptImg3 from '../../images/shap/circle-dots.png';

const AboutSection = (props) => {
	const [cardActive, setCardActive] = useState("Registro")
	return (
		<>
			<section className="section-area section-sp5 work-area" style={{ backgroundImage: "url(" + bg1 + ")", backgroundRepeat: " no-repeat", backgroundPosition: "center", backgroundSize: "100%" }}>
				<div className="container-sm">
					<div className="heading-bx text-center">
						<h6 className="title-ext text-secondary">Proceso de trabajo</h6>
						<h2 className="title">¿Cómo trabajamos?</h2>
					</div>
					<div className="row justify-content-center">
						<div className="col-lg-4 col-sm-6 mb-30">
							<div className={ `work-bx ${cardActive === 'Registro' ? 'active' : ''} `}>
								<div className="work-num-bx">01</div>
								<div className="work-content" style={{ height: 140 }}>
									<h5 className="title text-secondary mb-10">Registro</h5>
									<p>Registrate en nuestro sistema para estar al tanto de nuestras noticias y diferentes servicios.</p>
								</div>
								<Link to="/contact-us" className="btn btn-primary light">Ver más <i className="btn-icon-bx fas fa-chevron-right"></i></Link>
							</div>
						</div>
						<div className="col-lg-4 col-sm-6 mb-30">
							<div className={ `work-bx ${cardActive === 'Cita' ? 'active' : ''} `}>
								<div className="work-num-bx">02</div>
								<div className="work-content" style={{ height: 140 }}>
									<h5 className="title text-secondary mb-10">Agendar una Cita</h5>
									<p>Reserve una cita con nuestros profesionales. Ellos sabrán que proceso seguir.</p>
								</div>
								<Link to="/error-404" className="btn btn-primary light">Ver más <i className="btn-icon-bx fas fa-chevron-right"></i></Link>
							</div>
						</div>
						<div className="col-lg-4 col-sm-6 mb-30">
							<div className={ `work-bx ${cardActive === 'Tratamiento' ? 'active' : ''} `}>
								<div className="work-num-bx">03</div>
								<div className="work-content" style={{ height: 140 }}>
									<h5 className="title text-secondary mb-10">Realizar el tratamiento</h5>
									<p>Reciba una valoración de su salud dental y el proceso a seguir.</p>
								</div>
								<Link to={{ pathname: `/service-detail`, state: { service: 'tratamiento' } }}className="btn btn-primary light">Ver más <i className="btn-icon-bx fas fa-chevron-right"></i></Link>
							</div>
						</div>
					</div>
				</div>
				<img className="pt-img1 animate1" src={ptImg1} alt="" />
				<img className="pt-img2 animate2" src={ptImg2} alt="" />
				<img className="pt-img3 animate3" src={ptImg3} alt="" />
			</section>
		</>
	);
}

export default AboutSection;
